export default __webpack_public_path__ + "static/media/DharmaGothicE_Light_I.af446261.otf";